import { CreateArcgisSchemaApiRequest } from '../../../types/requests/arcgis-schemas/create-arcgis-schema.request';
import { client } from './client';

export const createArcgisSchema = (params: CreateArcgisSchemaApiRequest) => client.post('/arcgis-schemas', params);
